<template>
  <a-modal
    :visible="visible"
    wrap-class-name="checkwebsite-modal"
    :title="config.title"
    :width="config.width"
    :ok-text="config.confirmText"
    :cancel-text="config.cancelText"
    :mask-closable="false"
    @ok="submit"
    @cancel="close()"
  >
    <div class="cont">
      <div class="loading" v-if="!checkend">
        <a-spin :indicator="indicator" tip="网站验证中" />
      </div>
      <div class="success" v-else>
        <svg
          focusable="false"
          data-icon="check-circle"
          width="32px"
          height="32px"
          fill="currentColor"
          aria-hidden="true"
          viewBox="64 64 896 896"
        >
          <path
            d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm193.5 301.7l-210.6 292a31.8 31.8 0 01-51.7 0L318.5 484.9c-3.8-5.3 0-12.7 6.5-12.7h46.9c10.2 0 19.9 4.9 25.9 13.3l71.2 98.8 157.2-218c6-8.3 15.6-13.3 25.9-13.3H699c6.5 0 10.3 7.4 6.5 12.7z"
          ></path>
        </svg>
        <p>验证完成</p>
      </div>
      <div class="list">
        <div class="item" v-for="(item, index) in dataList" :key="index">
          <p>
            {{ item.domain }}<span v-if="checkend" @click="detail(item.langset_num)">详情</span>
          </p>
          <span class="status">{{ item.status_text }}</span>
        </div>
      </div>
      <p class="btn-box" v-if="checkend">
        <a-button @click="close()">关闭</a-button>
      </p>
    </div>
  </a-modal>
</template>
<script>
import API from "../api";
import moment from "moment";
import Vue from "vue";

export default {
  name: "Customer",
  data() {
    return {
      visible: false,
      config: {
        title: "账号网站验证",
        width: "70%",
      },
      dataList: [],
      checkend: false,
    };
  },
  props: {},
  created() {},
  mounted() {},
  computed: {},
  components: {},
  methods: {
    open(ids) {
      this.visible = true;
      this.getData(ids);
    },
    close() {
      this.visible = false;
      this.checkend = false;
    },
    getData(ids) {
      let THAT = this;
      API.customer
        .GET_CUSTOMER_LIST({
          ids: ids,
        })
        .then((res) => {
          if (res.data.code === 200) {
            THAT.dataList = res.data.data;
            THAT.sitesVerify(res.data.data);
          }
        });
    },
    sitesVerify(data) {
      let THAT = this;
      API.customer
        .SITES_VERIFY({
          customer_data: data,
        })
        .then((res) => {
          if (res.data.code === 201) {
            THAT.sitesVerify(res.data.data);
          } else if (res.data.code === 200) {
            THAT.checkend = true;
            THAT.dataList = res.data.data;
          } else if (res.data.code === 500) {
            THAT.close()
          }
        });
    },
    detail(data) {
      let THAT = this;
      THAT.$emit("detail", data);
    },
  },
};
</script>
<style scoped>
.loading {
  text-align: center;
}
.list {
  margin: 20px 0;
}
.list .item {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
  line-height: 1.3;
}
.list .item p {
  margin: 0;
}
.list .item p span {
  color: #1890ff;
  margin-left: 5px;
  cursor: pointer;
}
.success {
  text-align: center;
}
.success svg {
  color: #52c41a;
}
.btn-box {
  text-align: center;
}
</style>
<style>
.checkwebsite-modal .ant-modal-title {
  text-align: center;
}
.checkwebsite-modal .ant-modal-close-x {
  display: none;
}
.checkwebsite-modal .ant-modal-body {
  padding-bottom: 10px !important;
}
.checkwebsite-modal .ant-modal-footer {
  display: none;
}
</style>
